import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { ToastContainer } from "react-toastify";
import {
    setActions,
    setIsActionsClicked,
    setIsEdited,
    setValidationAction,
    store,
} from "./store";
import CustomIcons from "./CustomIcons";
import CustomSideFilter from "./CustomSideFilter";
import ZoneForm from "./ZoneForm";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import { store as storeGlobal } from "@components/VerticalLayout/store";
import { store as storeParent, setIsAddZone } from "../../store";
import { useAuthHeader } from "../../../../../../api/headersKeycloak";
import { EmptyColumn } from "../shared";

export default function Zone({ selectedRowShops }: any) {
    const [zoneData, setZoneData] = React.useState<any>([]);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [selectedRows, setSelectedRows] = React.useState<any>({});
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);
    const [
        isAddNewDeviseButtonClicked,
        setIsAddNewDeviseButtonClicked,
    ] = React.useState(false);

    const {
        isActionsClicked,
        isEdited,
        actions,
        validationAction,
    } = useSnapshot(store);
    const { isAddZone } = useSnapshot(storeParent);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    const { franchiseID } = useSnapshot(storeGlobal);
    const urlApi = `${process.env.REACT_APP_API_V2_URL}/settings/list/zone/c&c?franchiseID=${franchiseID}&shopId=${selectedRowShops[0].id_boutique_order}`;

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 999,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setSelectedRows={setSelectedRows}
                    setIsAddZone={setIsAddZone}
                    selectedRowShops={selectedRowShops}
                    setDataIsUpdated={setDataIsUpdated}
                    isAddZone={isAddZone}
                    zoneData={zoneData}
                />
            ),
            disableFilter: false,
        },
        {
            indexOFColumn: 0,
            columnName: t("Country"),
            customJsx: (e: any) => {
                return (
                    <span className="preview-text">
                        {selectedRowShops[0]["Country shop"]}
                    </span>
                );
            },
        },
        {
            indexOFColumn: 3,
            columnName: t("Tva"),
            customJsx: (e: any) => {
                return (
                    <span className="preview-text">
                        {e.selectedRow[t("Tva")]}
                    </span>
                );
            },
        },
    ];
    React.useEffect(() => {
        if (i18nextLng === "fr" || i18nextLng === "en") {
            setDataIsUpdated(true);
        }
    }, [i18nextLng]);

    React.useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    return (
        <React.Fragment>
            <div
                style={{
                    display: "grid",
                    minHeight: "calc(95vh - 350px)",
                    gridTemplateColumns: isAddZone ? "2fr 1fr " : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    url={urlApi}
                    showFilter
                    canSelect={true}
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={EmptyColumn}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setData={setZoneData}
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            setIsAddZone={setIsAddZone}
                            isAddZone={isAddZone}
                            setLocalFilterActive={setLocalFilterActive}
                            setSelectedRows={setSelectedRows}
                            setIsInInitializationModalOpened={
                                setIsInInitializationModalOpened
                            }
                            isEdited={isEdited}
                            selectedRows={selectedRows}
                        />
                    }
                    showGlobalFilter
                    canExpand
                    elevationTable={1}
                    minHeight={"calc(95vh - 470px)"}
                    maxHeight={"calc(95vh - 460px)"}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    setSelectedRows={setSelectedRows}
                    name="Choice"
                />
                {isAddZone && (
                    <ZoneForm
                        isAddZone={isAddZone}
                        setIsAddZone={setIsAddZone!}
                        setDataIsUpdated={setDataIsUpdated}
                        setLocalFilterActive={setLocalFilterActive}
                        isAddNewDeviseButtonClicked={
                            isAddNewDeviseButtonClicked
                        }
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        selectedRowShops={selectedRowShops}
                        ZoneData={zoneData}
                    />
                )}
                {isActionsClicked === true ? (
                    <ConfirmationUpdatingDataMessageModal
                        isModalOpened={isActionsClicked}
                        setIsModalOpened={setIsActionsClicked}
                        validationAction={validationAction}
                        actions={actions}
                        setIsEdited={setIsEdited}
                    />
                ) : null}
                {isInInitializationModalOpened === true ? (
                    <ConfirmationInitializationMessage
                        isModalOpened={isInInitializationModalOpened}
                        setIsModalOpened={setIsInInitializationModalOpened}
                        setIsClicked={setIsAddNewDeviseButtonClicked}
                        isClicked={isAddNewDeviseButtonClicked}
                        setIsEdited={setIsEdited}
                    />
                ) : null}
                <ToastContainer limit={1} />
            </div>
        </React.Fragment>
    );
}
